// @flow

/* eslint-disable filenames/match-exported */
import extractDate from './extractDate';

export default extractDate;
